import { Route } from '@angular/router';

import { DemoComponent } from './demo.component';

export const routes: Route[] = [
  { path: '', component: DemoComponent },
  { path: '**', component: DemoComponent }
];



// WEBPACK FOOTER //
// /Users/David/Sites/angular2-json-schema-form/src/demo/app/demo.routes.ts